import heroImg from '../assets/hero.png';
import { Link, useLocation } from 'react-router-dom';
import {useState} from "react";

export default function Hero() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollToSection = (id) => {
        if (location.pathname === '/') {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setIsMenuOpen(false);
    };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center text-white overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={heroImg} className="w-full h-full object-cover" alt="Hero" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>
      <div className="relative container mx-auto px-4 text-center z-10 py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight">
          ԸՆԿԵՐՈՒԹՅՈՒՆ, ՈՐԸ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ Է ՄԱՏՈՒՑՈՒՄ <br className="hidden md:block"/>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">ՀԱՄԱՊԱՏԱՍԽԱՆՈՒԹՅԱՆ ԳՆԱՀԱՏՄԱՆ</span> ՈԼՈՐՏՈՒՄ
        </h1>
          {location.pathname === '/' ? (
              <button
                  onClick={() => scrollToSection('contact')}
                  className="inline-block bg-white text-blue-900 hover:bg-blue-50 font-semibold py-4 px-10 rounded-full shadow-lg transition-all duration-300 mt-4"
              >
                  Կապ մեզ հետ
              </button>
          ) : (
              <Link
                  to="/#contact"
                  className="inline-block bg-white text-blue-900 hover:bg-blue-50 font-semibold py-4 px-10 rounded-full shadow-lg transition-all duration-300 mt-4"
              >
                  Կապ մեզ հետ
              </Link>
          )}

      </div>
    </section>
  );
}
